import SanitizedText from 'sanitize-text/components/SanitizedText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { useMessageAttachments } from '../hooks/useMessageAttachments';
import { MessageAttachment } from './MessageAttachment';
import { MessageBubble } from './MessageBubble';
import { MessageImage } from './MessageImage';
import { SensitiveHiddenMessage } from './SensitiveHiddenMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SENSITIVE = 'SENSITIVE';
const ThreadMessageAttachments = ({
  images,
  attachments
}) => {
  if (images.length === 0 && attachments.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [images.length > 0 && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "200",
      alignItems: "start",
      maxInlineSize: "100%",
      children: images.map(image => /*#__PURE__*/_jsx(MessageImage, {
        image: image
      }, image.fileId))
    }), attachments.length > 0 && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      gap: "200",
      flexWrap: "wrap",
      children: attachments.map(attachment => /*#__PURE__*/_jsx(MessageAttachment, {
        attachment: attachment.attachment,
        sensitiveAttachment: attachment.sensitiveAttachment,
        inThread: true
      }, attachment.fileId))
    })]
  });
};
const ThreadMessageBody = ({
  isSensitive,
  isHidden,
  messageRichText,
  messageText,
  images,
  attachments
}) => {
  const hasContent = messageRichText || messageText;
  const noPlainText = (messageText === null || messageText === void 0 ? void 0 : messageText.trim()) === '';
  if (isSensitive) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SensitiveHiddenMessage, {}), /*#__PURE__*/_jsx(ThreadMessageAttachments, {
        images: images,
        attachments: attachments
      })]
    });
  }
  if (isHidden) {
    return /*#__PURE__*/_jsx(Text, {
      fontStyle: "italic",
      typography: "body-100",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.ticketThread.messageContent.isHidden"
      })
    });
  }
  if (!hasContent) {
    return /*#__PURE__*/_jsx(Text, {
      fontStyle: "italic",
      typography: "body-100",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-portal-app.ticketThread.messageContent.noContent"
      })
    });
  }
  if (noPlainText) {
    return /*#__PURE__*/_jsx(ThreadMessageAttachments, {
      images: images,
      attachments: attachments
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-100",
      color: "text-core-default",
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: (messageRichText === null || messageRichText === void 0 ? void 0 : messageRichText.replace(/(background-)?color\s*:[^;"']+/gi, '')) || messageText || I18n.text('customer-portal-app.ticketThread.messageContent.noContent'),
        formattingOptions: {
          shouldPreventAutoLinker: true
        }
      })
    }), /*#__PURE__*/_jsx(ThreadMessageAttachments, {
      images: images,
      attachments: attachments
    })]
  });
};
export const ContentMessage = ({
  message,
  isInitialMessage = false,
  responders,
  attachmentsMap,
  sensitiveAttachmentsMetadata
}) => {
  const sender = 'sender' in message ? message.sender : undefined;
  const hiddenBy = 'hiddenBy' in message ? message.hiddenBy : undefined;
  const sensitivityType = 'sensitivityType' in message ? message.sensitivityType : undefined;
  const richText = 'richText' in message ? message.richText : undefined;
  const text = 'text' in message ? message.text : undefined;
  const responderKey = sender ? JSON.stringify(sender) : undefined;
  const threadResponder = responderKey ? responders[responderKey] : undefined;
  const [images, attachments] = useMessageAttachments([message], attachmentsMap, sensitiveAttachmentsMetadata);
  return /*#__PURE__*/_jsx(MessageBubble, {
    avatarUrl: threadResponder === null || threadResponder === void 0 ? void 0 : threadResponder.avatar,
    displayName: threadResponder === null || threadResponder === void 0 ? void 0 : threadResponder.displayName,
    timestamp: message.timestamp,
    header: isInitialMessage ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-portal-app.ticketThread.messageContent.welcomeMessageTypeHeader"
    }) : threadResponder ? threadResponder.displayName : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-portal-app.ticketThread.messageContent.automatedMessageTypeHeader"
    }),
    children: /*#__PURE__*/_jsx(ThreadMessageBody, {
      isSensitive: sensitivityType === SENSITIVE,
      isHidden: Boolean(hiddenBy),
      messageRichText: richText,
      messageText: text,
      images: images,
      attachments: attachments
    })
  });
};